import React from 'react';

/**
 * Modal d'avertissement de timeout de session.
 * S'affiche quand l'utilisateur est inactif depuis trop longtemps.
 */
export default function SessionTimeoutWarning({ countdown, onStayConnected, onLogout }) {
  const pct = Math.round((countdown / 60) * 100);
  const isUrgent = countdown <= 15;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      role="alertdialog"
      aria-modal="true"
      aria-label="Session expiring"
    >
      <div className="w-full max-w-sm rounded-2xl bg-white shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        {/* Progress bar */}
        <div className="h-1.5 bg-gray-100">
          <div
            className={`h-full transition-all duration-1000 ease-linear rounded-r-full ${
              isUrgent ? 'bg-red-500' : 'bg-amber-500'
            }`}
            style={{ width: `${pct}%` }}
          />
        </div>

        <div className="px-6 pt-6 pb-5">
          {/* Icon */}
          <div className={`mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-4 ${
            isUrgent ? 'bg-red-100' : 'bg-amber-100'
          }`}>
            <svg
              className={`w-7 h-7 ${isUrgent ? 'text-red-600' : 'text-amber-600'}`}
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          {/* Text */}
          <h2 className="text-center text-lg font-bold text-gray-900 mb-1">
            Session inactive
          </h2>
          <p className="text-center text-sm text-gray-600 mb-4">
            Vous allez être déconnecté dans
          </p>

          {/* Countdown */}
          <div className="flex items-center justify-center mb-5">
            <span className={`text-4xl font-bold tabular-nums ${
              isUrgent ? 'text-red-600' : 'text-amber-600'
            }`}>
              {countdown}
            </span>
            <span className="text-sm text-gray-500 ml-2">secondes</span>
          </div>

          {/* Actions */}
          <div className="flex flex-col gap-2.5">
            <button
              type="button"
              onClick={onStayConnected}
              className="w-full rounded-xl bg-[#113a5b] px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-[#0e314c] focus:outline-none focus:ring-2 focus:ring-[#113a5b]/50 transition-colors"
            >
              Rester connecté
            </button>
            <button
              type="button"
              onClick={onLogout}
              className="w-full rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-colors"
            >
              Se déconnecter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
